import { chartColors, getFinancialHealthColor } from '@UILibrary/utils'

export const buildDoughnutChartDataProp = (currentPercentage, benchmark) => {
  const remainingPercentage = 100 - currentPercentage

  const color = getFinancialHealthColor(currentPercentage, benchmark, true)

  return {
    labels: ['Invested', 'Remaining'],
    datasets: [
      {
        label: 'Investment Distribution',
        data: [currentPercentage, remainingPercentage],
        backgroundColor: [color, chartColors['gray-80']],
        hoverOffset: 4,
      },
    ],
  }
}

export const buildRadarChartDataProp = (data) => {
  return ({
    labels: data.map((d) => d.label),
    datasets: [{
      backgroundColor: chartColors['true-blue-5'],
      borderColor: chartColors['true-blue-10'],
      data: data.map((d) => d.value),
      fill: true,
      label: 'Percentage',
      pointBackgroundColor: chartColors['true-blue-5'],
      pointBorderColor: chartColors['white'],
      pointHoverBackgroundColor: chartColors['true-blue-5'],
      pointHoverBorderColor: chartColors['true-blue-10']
    }]
  })
}
